<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      fill="currentColor"
      d="M9.29013 4.69684C5.92621 4.69684 3.19922 7.42383 3.19922 10.7877C3.19922 12.2291 3.69865 13.5511 4.53471 14.5941C4.88014 15.025 4.81085 15.6544 4.37993 15.9998C3.94901 16.3453 3.31965 16.276 2.97421 15.845C1.86397 14.4601 1.19922 12.7002 1.19922 10.7877C1.19922 6.31926 4.82164 2.69684 9.29013 2.69684C13.0608 2.69684 15.8934 5.29815 17.0776 8.03971C18.8383 8.16732 20.2124 8.78451 21.1734 9.77078C22.2485 10.8742 22.6992 12.3299 22.6992 13.758C22.6992 14.8242 22.383 15.4527 21.9719 16.1635C21.495 16.9877 20.8082 17.6746 19.984 18.1514C19.5059 18.4279 18.8942 18.2645 18.6176 17.7865C18.3411 17.3084 18.5045 16.6967 18.9825 16.4202C19.5039 16.1186 19.9391 15.6834 20.2406 15.162C20.5837 14.5691 20.6992 14.3062 20.6992 13.758C20.6992 12.7384 20.3803 11.8227 19.7409 11.1665C19.1134 10.5225 18.0708 10.0194 16.4026 10.0151C16.3349 10.0165 16.2679 10.0111 16.2025 9.99913C16.0436 9.97051 15.8978 9.90437 15.7745 9.81021C15.6107 9.68506 15.4866 9.51042 15.4248 9.3086C14.6339 6.96642 12.2992 4.69684 9.29013 4.69684Z"
    />
    <path
      fill="currentColor"
      d="M9.70631 14.7071C9.31579 15.0976 8.68262 15.0976 8.2921 14.7071C7.90158 14.3166 7.90158 13.6834 8.2921 13.2929L11.1507 10.4343C11.6193 9.96568 12.3791 9.96569 12.8477 10.4343L15.7063 13.2929C16.0968 13.6834 16.0968 14.3166 15.7063 14.7071C15.3158 15.0976 14.6826 15.0976 14.2921 14.7071L12.9992 13.4142V19C12.9992 19.5523 12.5515 20 11.9992 20C11.4469 20 10.9992 19.5523 10.9992 19V13.4142L9.70631 14.7071Z"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
